import { render, staticRenderFns } from "./CompareText.vue?vue&type=template&id=7f995661"
import script from "./CompareText.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompareText.vue?vue&type=style&index=0&id=7f995661&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports